var map = {
	"./HITACHI.png": 333,
	"./Oliver.png": 2614,
	"./SMC.png": 6556,
	"./TOSHIBA.png": 1059,
	"./TOTO.png": 5803,
	"./TOYODENKI.png": 7583,
	"./TPR.png": 3117,
	"./google.png": 678,
	"./lenovo.png": 822,
	"./mizuno.png": 5687,
	"./oji.png": 231,
	"./sony.png": 6510,
	"./三菱商事.png": 2848,
	"./东洋纺.png": 7060,
	"./中部化学株式会社.png": 7569,
	"./伊藤忠商事.png": 1156,
	"./华勤.png": 6917,
	"./华星光电.png": 3292,
	"./大金工业.png": 6538,
	"./旭洋株式会社.png": 5970,
	"./柯尼卡美能达.png": 418,
	"./雅马哈.png": 5890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3968;